import createMediator from '@core-ui/mediator';

const Mediator = createMediator('ExampleMediator', { withState: true });

export default class ExampleMediator extends Mediator {
  constructor(props) {
    super(props);
    // Create initial state
    this.state = {
      isVisible: props.isVisible,
    };

    // Setup actions
    this.actions = {
      updateVisibility: this.updateVisibility
    };
  }

  // Define action methods
  updateVisibility = (isVisible) => {
    this.setState({ isVisible });
  }
}
